import GenerateMorePopover from 'trunks/controllers/admin/settings/nav.js'
import SettingsNavigator from 'trunks/vue/admin/compositions/settings_sidebar/settings_navigator.js'
import MessageExceptionTemplatesIndex from 'trunks/vue/admin/components/templates/message_exception_templates_index.js'
import MessageExceptionTemplateForm from 'trunks/vue/admin/components/templates/message_exception_template_form.js'

function parsePayload(element, key) {
  if (!element) return {}
  return JSON.parse(element.dataset[key] || '{}')
}

class Admin__MessageExceptionTemplatesController extends Skylark.App.BaseController {
  index() {
    this._generateSettingsSidebarView('settings__message_exception_templates')
    const container = DomMaster.find('#js-message-exception-templates-index').node
    if (!container) return

    new MessageExceptionTemplatesIndex({
      el: container,
      propsData: {
        templatesData: parsePayload(container, 'templates')
      }
    })
  }

  show() {
    this._generateSettingsSidebarView('settings__message_exception_templates')
    const container = DomMaster.find('#js-message-exception-template-form').node
    if (!container) return

    new MessageExceptionTemplateForm({
      el: container,
      propsData: {
        formData: parsePayload(container, 'template')
      }
    })
  }
}

Admin__MessageExceptionTemplatesController.include(GenerateMorePopover, SettingsNavigator)

export default Admin__MessageExceptionTemplatesController
